import { useLayoutEffect, useMemo } from 'react';
// import { useStore } from 'src/stores';
import { page } from 'src/locale';
import { useWindowSize } from 'src/core/hooks';
import { HomePageProduct } from './products';

/**
 * <ProductsCarousel /> props
 */
const useProductsCarouselProps = () => {
  const { width } = useWindowSize();
  // const {
  //   formStore: { locale }
  // } = useStore();

  const locale = 'ua';

  const products = page.productsCarousel?.products;

  useLayoutEffect(() => {
    const slickTrackElement = document.querySelector(
      '.slick-track'
    ) as HTMLElement;

    if (slickTrackElement && width < 425) {
      slickTrackElement.style.minWidth =
        slickTrackElement.childElementCount * 310 +
        (slickTrackElement.childElementCount - 1) * 15 +
        35 +
        'px';
    }
  }, [width]);

  return {
    width,
    locale,
    products,
    page
  };
};

export { useProductsCarouselProps };
